import Component from '@glimmer/component';

// Read-only display of an initiative's duration. Duration is recalculated from
// the number of planning weeks whenever a week is created or deleted (see
// `app/models/week.js`), so it is no longer editable from the table, the
// summary panel or the initiative form.
export default class InitiativesTableDurationSelectorComponent extends Component {
  get initiative() {
    return this.args.initiative;
  }
}
